import { makeAutoObservable } from 'mobx';
import { UserInfo } from '@/store/admin/userInfo';

class UserStore {
  user: UserInfo | null = null;
  isInitialized = false;

  constructor() {
    makeAutoObservable(this);
  }

  setUser(user: UserInfo) {
    this.user = user;
  }

  clearUser() {
    this.user = null;
  }

  async initialize() {
    try {
      // Add your initialization logic here
      // For example, fetch user data
      this.isInitialized = true;
    } catch (error) {
      console.error('Initialization failed:', error);
      throw error;
    }
  }

  getCurrentUserId(): number {
    return this.user?.userId || 0;
  }
}

const userStore = new UserStore();
export default userStore;
